<template>
  <div>
    <div class="row" v-if="this.desc">
      <h2>Lexicon words -<b>{{this.desc}}</b>-</h2>
    </div>

    <div class="row">
      <p class="float-left">
        Edit lexicon entries. click "<u>Add Word</u>" to add a new word to the lexicon, click "<u>Import Words</u>" to download words list, click "<u>Export Words</u>" to add words to the list by file upload, and click "<u>Manage Builds</u>" to manage this lexicon's builds.
      </p>
    </div>

    <div class="row text-center">
      <div class="col-md-12">
        <!-- <label class="btn btn-secondary" @click.stop="onAddWord($event)">
          Add Word
        </label>&nbsp; -->

        <label class="btn mx-1 btn-primary btn-md" @click.stop="onImportWords($event)">
          Import Words
        </label>

        <label class="btn mx-1 btn-primary btn-md">
          Export Words <input ref="dataFile" type="file" hidden accept=".csv" @change="onExportFilePicked($event)">
        </label>

        <label class="btn mx-1 btn-primary btn-md" v-if="this.requestCompleted && this.rows.length !== 0"  @click.stop="onGenerateBuild($event)">
          Generate Build
        </label>

        <label class="btn mx-1 btn-primary btn-md" @click.stop="onManageBuilds($event)">
          Manage Builds
        </label>

        <!-- <label class="btn mx-1 btn-primary btn-md" @click.stop="onManageTranscribeModels($event)">
          Transcribe Models
        </label> -->
      </div>
    </div>

    <div style="height: 70px;" class="d-flex justify-content-center align-items-center">
      <div class="d-flex justify-content-center align-items-center bg-secondary w-100 rounded" style="height: 70px;">
        <div class="d-flex justify-content-center w-75">
              <input
                v-on:keyup.enter="addWord()"
                v-model="newWordVal"
                class="gridjs-input form-control"
                style="text-align: center;"
                type="text"
                value=""
                placeholder="Add word... (Hit ENTER key to add when done typing)" />
              <button @click="addWord()" class="btn mx-2 btn-primary btn-md">Enter</button>
        </div>
      </div>
    </div>

    <div v-if="this.displayFlashError" class="row text-center">
      <div class="col-md-12">
        <div class="alert alert-danger" role="alert">
          {{flashMsgError}}
        </div>
      </div>
    </div>

    <br v-if="this.displayFlashSuccess" />
    <div v-if="this.displayFlashSuccess" class="row text-center">
      <div class="col-md-12">
        <div class="alert alert-success" role="alert">
          {{flashMsgSuccess}}
        </div>
      </div>
    </div>

    <br v-if="this.requestCompleted && this.rows.length === 0" />
    <br v-if="this.requestCompleted && this.rows.length === 0" />
    <br v-if="this.requestCompleted && this.rows.length === 0" />
    <div class="row d-flex justify-content-center">
      <div v-if="this.requestCompleted && this.rows.length === 0">
        Words list is empty, click on "Add Word" or "Export Words" to add to the list.<br />
      </div>
    </div>

    <div v-if="this.requestCompleted && this.rows.length === 0" class="row d-flex justify-content-center">
      <img src="@/assets/no-data.png" />
    </div>

    <div v-if="this.rows.length > 0">
      <grid ref="wordsGrid" :styles="gridStyle" :cols="cols" :rows="rows" :sort="true" :pagination="pagination" :search="search"></grid>
    </div>

    <br />
    <div class="d-flex flex-row-reverse">
      <div>
        <label v-if="this.actionsList.length > 0" class="btn mx-1 btn-primary btn-md" @click.stop="generateSuggestions()">
          Generate guides
        </label>
        <label v-if="this.actionsList.length === 0" class="btn mx-1 btn-primary btn-md disabled">
          Generate guides
        </label>
        <label v-if="this.actionsList.length > 0" class="btn mx-1 btn-primary btn-md" @click.stop="deleteLexiconWords()">
          Delete words
        </label>
        <label v-if="this.actionsList.length === 0" class="btn mx-1 btn-primary btn-md disabled">
          Delete words
        </label>
      </div>
    </div>

    <br />
    <div v-if="this.displayLoading" class="d-flex justify-content-center">
      <div>
        <br /><br /><br />
        <br /><br /><br />
        <button class="btn btn-primary" type="button" disabled>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Loading data, please wait...
        </button>
      </div>
    </div>

    <eModal v-model="modal" ref="modal"></eModal>
    <vue-confirm-dialog></vue-confirm-dialog>
  </div>
</template>

<script>
import io from 'socket.io-client'
import apiClient from '@/services/api_client_saas.js'
import Grid from 'gridjs-vue'
import { eModal } from 'vue-eagle-modal'
import router from '../router'

export default {
  props: {
  },
  components: {
    Grid,
    eModal
  },
  data () {
    return {
      socket: null,
      modelOptions: [],
      modal: {
        title: 'Generate Lexicon Build',
        theme: 'mojave',
        items: [
          {
            label: 'Description:',
            name: 'desc',
            type: 'text',
            value: '',
            attr: { required: true, autofocus: 'autofocus' }
          }
        ]
      },
      desc: {},
      rows: [],
      newWordVal: '',
      currentFocus: null,
      actionsList: [],
      uploadURL: '',
      displayLoading: true,
      disableGenerateGuides: false,
      flashMsgSuccess: '',
      displayFlashSuccess: false,
      flashMsgError: '',
      displayFlashError: false,
      requestCompleted: false,
      displayFlash: false,
      groupId: 0,
      nextItem: 0,
      pagination: {
        enabled: true,
        limit: 8,
        summary: true
      },
      search: true,
      gridStyle: {
        table: {
          border: '3px solid #ccc'
        },
        th: {
          'background-color': 'rgba(0, 0, 0, 0.1)',
          color: '#000',
          'border-bottom': '3px solid #ccc',
          'text-align': 'center'
        },
        td: {
          'text-align': 'center',
          'vertical-align': 'middle',
          margin: 'auto'
        }
      },
      cols: [
        {
          name: 'Word',
          formatter: (cell, row) => {
            const linkAction = this.$gridjs.h(
              'span',
              { onClick: () => this.navigateToLexiconWordsList(row) },
              this.$gridjs.html('<span><u>' + cell + '</u></span>')
            )
            return [linkAction]
          }
        },
        {
          name: 'Guides',
          sort: false,
          width: '50%',
          formatter: (cell, row) => {
            let html = ''
            const saveDoc = '<label class="btn"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/></svg></label>&nbsp;'
            if (row.cells[2].data && row.cells[2].data.length > 0) {
              html = '<input class="gridjs-input dummy-class" id="sugg-' + row.cells[1].data + '" style="width: 80%;" type="text" value="' + row.cells[2].data + '" /> ' + saveDoc
            } else if (row.cells[2].data === 0 || row.cells[2].data === false) {
              html = '<span style="width: 80%;"><button class="btn btn-primary" type="button" disabled><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guides are being generated...</button></span>'
            } else {
              html = '<input class="gridjs-input dummy-class" id="sugg-' + row.cells[1].data + '" style="width: 80%;" type="text" value="" placeholder="No guides available." /> ' + saveDoc
            }

            if (this.disableGenerateGuides) {
              html = html.replace('input', 'input disabled')
            }

            const actionList = this.$gridjs.h(
              'span',
              { onClick: () => this.saveGuides(row.cells[1].data) },
              this.$gridjs.html(html)
            )

            return [actionList]
          }
        },
        {
          name: 'Bulk Actions',
          sort: false,
          width: '4%',
          formatter: (cell, row) => {
            let checkbox = ''
            if (this.disableGenerateGuides) {
              checkbox = '<input disabled id="check-' + row.cells[1].data + '" class="align-center justify-center" type="checkbox">'
            } else {
              checkbox = '<input id="check-' + row.cells[1].data + '" class="align-center justify-center" type="checkbox" value="" id="flexCheckDefault">'
              for (const i in this.actionsList) {
                if (this.actionsList[i] === row.cells[1].data) {
                  checkbox = '<input id="check-' + row.cells[1].data + '" checked=checked class="align-center justify-center" type="checkbox" value="" id="flexCheckDefault">'
                }
              }
            }
            const actionList = this.$gridjs.h(
              'span',
              { onClick: () => this.addToActionList(row.cells[1].data) },
              this.$gridjs.html(checkbox)
            )
            return [actionList]
          }
        }
      ]
    }
  },
  created: function () {
    const _this = this

    this.socket = io('http://developer.apptek.com:5001/saas')

    this.socket.on('connect', function () {
      console.log('Browser is connected to SocketIO successfully!')
    })

    this.socket.on('guides_check_response', function (msg, cb) {
      const items = msg.data.split('#')
      for (let i = 0; i < items.length; i++) {
        const tmp = items[i].split('|')
        for (let j = 0; j < _this.rows.length; j++) {
          if (parseInt(tmp[0]) === parseInt(_this.rows[j][1])) {
            _this.rows[j][2] = tmp[1]
          }
        }
      }

      _this.$refs.wordsGrid.grid.updateConfig({ data: _this.rows }).forceRender()
      _this.disableGenerateGuides = false
    })

    window.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        _this.saveGuides(parseInt(e.target.id.split('-')[1]), 'enter', e)
      }
    })
  },
  mounted: function () {
    this.groupId = this.$route.params.id
    this.getModelOptions()

    const em = this.$refs.modal.open()
    em.close() // TODO: => The only way to get the const "em" populated with modal object is by opening the moodal, this makes no sense as we directly close it, this will be rewritten using a better modal component.
    em.onsave((m) => {
      m.loading()
      apiClient.post('/api/lexicon/build/' + this.groupId, {
        groupId: this.groupId,
        desc: m.getItems()[0].value,
        buildModel: m.getItems()[1].value.split(' => ')[0]
      }).then((response) => {
        if (response.status === 201) {
          this.flashMsgSuccess = 'Build was submitted successfully'
          this.displayFlashSuccess = true
          m.getItems()[0].value = ''
          m.loaded()
          m.close()
          setTimeout(() => {
            this.displayFlashSuccess = false
          }, 5000)
        }
      }).catch((error) => {
        m.loaded()
        if (error.response) {
          console.log(error.response.data)
        }
      })
    })

    apiClient.get('/api/lexicons/item/' + this.groupId).then((response) => {
      this.desc = response.data.group[0].lexicon_description
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data)
      }
    })

    // TODO: all calls to /api/lexicons/words/list/ should be implemented in a single function and call it
    this.disableGenerateGuides = false
    apiClient.get('/api/lexicons/words/list/' + this.groupId).then((response) => {
      for (let i = 0; i < response.data.length; i++) {
        if (response.data[i].suggestions === false) {
          this.disableGenerateGuides = true
        }

        this.rows.push([
          response.data[i].word,
          response.data[i].id,
          response.data[i].suggestions
        ])
      }

      this.requestCompleted = true
      this.displayLoading = false
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data)
      }
    })
  },
  methods: {
    getModelOptions: function () {
      apiClient.get('/api/lexicon/transcribe-models-list?listall=true&group_id=' + this.groupId).then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          this.modelOptions.push(response.data[i][1] + ' => ' + response.data[i][0])
        }
        this.modelOptions.sort()

        this.modal.items.push({
          label: 'Select Model',
          name: 'Model',
          type: 'select',
          value: '',
          options: this.modelOptions,
          attr: { required: true }
        })

        return this.modelOptions
      })
    },
    moveCursor: function (e) {
      e.preventDefault()
      let input = document.getElementById('sugg-' + this.nextItem)
      if (!input) {
        // determain in which page nextItem is:
        let targetPage = 1
        for (let i = 0; i < this.rows.length; i++) {
          if (this.rows[i][1] === this.nextItem) {
            targetPage = Math.ceil(i / 9)
            break
          }
        }

        if (Math.ceil(this.rows.length / 8) > targetPage - 1 && this.$refs.wordsGrid) {
          this.$refs.wordsGrid.grid.updateConfig({ data: this.rows, pagination: { limit: 8, page: targetPage } }).forceRender()
          setTimeout(() => {
            input = document.getElementsByClassName('gridjs-input')[2]
            const len = input.value.length
            input.focus()
            input.setSelectionRange(len, len)
          }, 0)
        } else {
          console.log('تعبت!')
        }
      } else {
        const len = input.value.length
        input.focus()
        input.setSelectionRange(len, len)
      }
    },
    saveGuides: function (id, source, evt) {
      const inputData = document.getElementById('sugg-' + id).value.trim()
      if (source !== 'enter') {
        return
      }

      this.nextItem = 0
      for (let i = 0; i < this.rows.length; i++) {
        if (this.rows[i][1] === id) {
          this.nextItem = this.rows[i + 1][1]
          if (this.rows[i][2] === inputData || (!this.rows[i][2] && !inputData)) {
            this.moveCursor(evt)
            return
          }
        }
      }

      if (!inputData) {
        return
      }

      if (document.getElementById('sugg-' + this.nextItem)) {
        this.moveCursor(evt)
      }

      apiClient.post('/api/lexicon/suggest-edit', {
        id: id,
        suggestions: inputData,
        groupId: this.groupId
      }).then((response) => {
        if (response.status === 201) {
          // this.flashMsgSuccess = 'Guides saved successfully.'
          // this.displayFlashSuccess = false
          // this.$refs.wordsGrid.grid.updateConfig({ data: this.rows }).forceRender()
        } else {
          this.flashMsgError = 'Something went wrong while saving thee word!'
          this.displayFlashError = true
          setTimeout(() => {
            this.displayFlashError = false
          }, 5000)
        }
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    },
    addWord: function () {
      if (!this.newWordVal.trim()) {
        this.flashMsgError = 'Empty values are not allowed!'
        this.displayFlashError = true
        setTimeout(() => {
          this.displayFlashError = false
        }, 5000)

        return false
      }

      let isDouplicate = false
      for (let i = 0; i < this.rows.length; i++) {
        if (this.rows[i][0] === this.newWordVal.trim()) {
          isDouplicate = true
          this.flashMsgError = 'Douplicate words are not allowed!'
          this.displayFlashError = true
          setTimeout(() => {
            this.displayFlashError = false
          }, 5000)

          return false
        }
      }

      if (!isDouplicate) {
        apiClient.post('/api/lexicons/word/add', {
          word: this.newWordVal,
          group_id: this.groupId,
          guides: '',
          phonemes: '',
          colors: ''
        }).then((response) => {
          if (response.status === 201) {
            this.flashMsgSuccess = 'Word was added successfully.'
            this.displayFlashSuccess = true
            setTimeout(() => {
              this.displayFlashSuccess = false
            }, 5000)
            this.newWordVal = ''
            this.disableGenerateGuides = false
            apiClient.get('/api/lexicons/words/list/' + this.groupId).then((response) => {
              this.rows = []
              for (let i = 0; i < response.data.length; i++) {
                if (response.data[i].suggestions === false) {
                  this.disableGenerateGuides = true
                }
                this.rows.push([
                  response.data[i].word,
                  response.data[i].id,
                  response.data[i].suggestions
                ])
              }

              this.requestCompleted = true
            }).catch((error) => {
              if (error.response) {
                console.log(error.response.data)
              }
            })
          } else {
            this.flashMsgError = 'Something went wrong while saving thee word!'
            this.displayFlashError = true
            setTimeout(() => {
              this.displayFlashError = false
            }, 5000)
          }
        }).catch((error) => {
          if (error.response) {
            console.log(error.response.data)
          }
        })
      }
    },
    generateSuggestions: function () {
      this.disableGenerateGuides = true
      apiClient.post('/api/lexicons/words/get-suggestions', {
        words: this.actionsList.join(','),
        group_id: this.groupId
      }).then((response) => {
        if (response.status === 201) {
          this.requestCompleted = true
          this.displayFlashSuccess = false
          // this.flashMsgSuccess = 'Guides request sent successfully.'

          let data = ''
          for (let i = 0; i < this.actionsList.length; i++) {
            data += this.groupId + '|' + this.actionsList[i] + '|' + response.data.reqs[i] + '|' + ','
          }

          this.socket.emit('guides_check', { data: data.substring(0, data.length - 1), cid: response.data.cid })

          setTimeout(() => {
            const _rows = this.rows
            for (let i = 0; i < _rows.length; i++) {
              for (let j = 0; j < this.actionsList.length; j++) {
                if (_rows[i][1] === this.actionsList[j]) {
                  _rows[i][2] = 0
                }
              }
            }

            this.disableGenerateGuides = true
            this.actionsList = []
            this.$refs.wordsGrid.grid.updateConfig({ data: _rows }).forceRender()
          }, 500)
        }
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    },
    addToActionList: function (id) {
      if (document.getElementById('check-' + id).checked && !this.actionsList.includes(id)) {
        this.actionsList.push(id)
      } else if (!document.getElementById('check-' + id).checked) {
        const index = this.actionsList.indexOf(id)
        if (index !== -1) {
          this.actionsList.splice(index, 1)
        }
      }
    },
    navigateToLexiconWordsList: function (row) {
      // router.push({ name: 'LexiconWordsView', params: { id: row.cells[1].data } })
    },
    onImportWords (event) {
      apiClient.get('/api/lexicons/words/import/' + this.groupId).then((response) => {
        if (response.status === 200) {
          let words = ''
          for (const i in response.data.words) {
            let gotSuggestions = false
            for (const j in response.data.suggestions) {
              if (response.data.words[i].id === response.data.suggestions[j].id) {
                words += response.data.words[i].word + ',"' + response.data.suggestions[j].suggestion_data + '"' + '\n'
                gotSuggestions = true
              }
            }
            if (!gotSuggestions) {
              words += response.data.words[i].word + '\n'
            }
          }
          window.location.assign(encodeURI('data:text/csv;charset=utf-8,' + words))
        }
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    },
    onExportFilePicked: function (event) {
      const file = this.$refs.dataFile.files[0]
      if (!file || (file.type !== 'text/plain' && file.type !== 'text/csv')) {
        return
      }

      const reader = new FileReader()
      reader.readAsText(file, 'UTF-8')
      reader.onload = evt => {
        apiClient.post('/api/lexicons/words/export', {
          data: evt.target.result,
          group_id: this.groupId
        }).then((resp) => {
          if (resp.status === 201) {
            this.disableGenerateGuides = false
            apiClient.get('/api/lexicons/words/list/' + this.groupId).then((response) => {
              this.rows = []
              for (let i = 0; i < response.data.length; i++) {
                if (response.data[i].suggestions === false) {
                  this.disableGenerateGuides = true
                }
                this.rows.push([
                  response.data[i].word,
                  response.data[i].id,
                  response.data[i].suggestions
                ])
              }
              this.requestCompleted = true
            }).catch((error) => {
              if (error.response) {
                console.log(error.response.data)
              }
            })
          }
        }).catch((error) => {
          if (error.response) {
            console.log(error.response.data)
          }
        })
      }
      reader.onerror = evt => {
        console.error(evt)
      }
    },
    onGenerateBuild: function (e) {
      e.preventDefault()
      document.activeElement.blur()
      this.$data.em = this.$refs.modal.open()
    },
    onManageBuilds: function (event) {
      router.push({ name: 'LexiconBuildsManagement', params: { id: this.groupId } })
    },
    onManageTranscribeModels: function (event) {
      router.push({ name: 'LexiconTranscribeManagement' })
    },
    editLexiconWord: function (row) {
      router.push({ name: 'LexiconWordsEdit', params: { id: row.cells[1].data, word: row.cells[0].data } })
    },
    deleteLexiconWords: function (id) {
      this.$confirm({
        message: 'You are about to delete the selected words, Are you sure?',
        button: {
          no: 'No',
          yes: 'Yes, Delete.'
        },
        callback: (confirm) => {
          if (confirm) {
            apiClient.put('/api/lexicons/word/delete', {
              id: this.actionsList.join(',')
            }).then((response) => {
              if (response.status === 204) {
                const tmp = this.actionsList
                this.actionsList = []

                const tmpIndex = []
                const tmpRows = []
                for (let i = 0; i < this.rows.length; i++) {
                  for (let j = 0; j < tmp.length; j++) {
                    if (this.rows[i][1] === tmp[j]) {
                      continue
                    } else {
                      if (!tmpIndex.includes(tmp[j])) {
                        tmpIndex.push(tmp[j])
                      }
                    }
                  }
                }

                for (let i = 0; i < this.rows.length; i++) {
                  if (tmpIndex.includes(this.rows[i][1])) {
                    continue
                  } else {
                    tmpRows.push(this.rows[i])
                  }
                }

                this.rows = tmpRows
              }
            }).catch((error) => {
              if (error.response) {
                console.log(error.response.data)
              }
            })
          }
        }
      })
    }
  },
  computed: {
    hasData () {
      return this.rows.length > 0
    }
  }
}
</script>
